interface SortableHeaderProps<T> {
  label: string;
  sortKey: keyof T;
  currentSort: { key: keyof T; direction: 'asc' | 'desc' | null } | null;
  onSort: (key: keyof T) => void;
}

export const SortableHeader = <T extends object>({
  label,
  sortKey,
  currentSort,
  onSort,
}: SortableHeaderProps<T>) => {
  const isSorted = currentSort?.key === sortKey;
  
  return (
    <th
      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
      onClick={() => onSort(sortKey)}
    >
      <div className="flex items-center space-x-1">
        <span>{label}</span>
        <span className="text-gray-400">
          {isSorted && (
            <svg
              className={`w-4 h-4 transition-transform ${
                currentSort?.direction === 'desc' ? 'transform rotate-180' : ''
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              />
            </svg>
          )}
        </span>
      </div>
    </th>
  );
}; 